<template>
    <PortalAbonadosComponent :loading="loading" :abono="abono">
        <template v-slot:buscar-abonado>
            <BuscarAbonado :data="data" :loading="loading" :error="mensaje" @buscarAbonado="buscarAbono" />
        </template>
        <template v-slot:content>
            <b-col v-if="!esFerrol" cols="12" md="4" class="my-auto text-center pb-3">
                <img :src="'data:image/png;base64, ' + abono.attributes.QRImage" alt="" style="height: 150px"/>
            </b-col>
            <b-col cols="12" :md="esFerrol ? 12 : 8" style="font-weight: bold;">
                <b-row>
                    <b-col cols="12">
                        <span class="altcolor">Nº de abonado:</span> {{ abono.info.Num_Socio }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Nombre:</span> {{ abono.info.Nombre }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Email:</span> {{ abono.info.EMail }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Dirección:</span> {{ abono.info.Direccion }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Fecha de alta:</span> {{ abono.info.Fecha_Alta }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Provincia:</span> {{ abono.info.Provincia }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Localidad:</span> {{ abono.info.Localidad }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Abono:</span> {{ abono.info.Tipo_Abono }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Fila:</span> {{ abono.info.Fila }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Asiento:</span> {{ abono.info.Asiento }}
                    </b-col>
                    <b-col cols="12">
                        <span class="altcolor">Zona:</span> {{ abono.info.ZonaNombre }}
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" class="mt-3 d-flex flex-column flex-md-row justify-content-between">
                <div class="mb-2 mb-md-0 d-flex flex-column flex-md-row" v-if="abono.renovado && showLfpActions">
                    <a class="button mb-2 mb-md-0 mr-md-2" target="_blank" :href="getPdfEnlace()">
                        <i class="far fa-file-pdf" :disabled="loading"></i> Descargar PDF
                    </a>
                </div>
                <div class="d-flex flex-column flex-md-row">
                    <button v-if="showLfpActions" type="button" @click="showModal('listadoPartidos')" class="button mb-2 mb-md-0 mr-md-2" name="button">Liberar/Recuperar asiento</button>
                    <button type="button" @click="showModal('editarDatos')" class="button mb-2 mb-md-0 mr-md-2" name="button" :disabled="loading">Editar datos</button>
                    <button type="button" @click="showModal('cambioPin')" class="button mb-2 mb-md-0 mr-md-2" name="button" :disabled="loading">Cambiar PIN</button>
                    <router-link :to="{ name: 'mi-abono.cambio-asiento', params: { id_persona: data.id_persona, pin: data.pin } }" class="button" name="button" v-if="!abono.renovado">Cambiar Asiento</router-link>
                </div>
            </b-col>
            <Partidos :abono="abono" @close="closeModal" ref="partidosModal" />
            <EditarDatos @close="closeModal" @editarDatos="editarDatos" :abono="abono" :loading="loading"/>
            <CambioPin @close="closeModal" @cambiarPin="cambiarPIN" :id_persona="data.id_persona" :pin_actual="data.pin" :loading="loading"/>
        </template>
    </PortalAbonadosComponent>
</template>

<script>
    import BuscarAbonado from '@/components/frontend/lfp/BuscarAbonado';
    import { TEATRO_HASH_CD_ELDENSE } from '@/constants/teatros';
    import CambioPin from '@/views/frontend/mi_abono/modals/CambioPin.vue';
    import EditarDatos from '@/views/frontend/mi_abono/modals/EditarDatos.vue';
    import Partidos from '@/views/frontend/mi_abono/modals/Partidos.vue';
    import PortalAbonadosComponent from './PortalAbonadosComponent.vue';
    import { useHead } from '@/composables/common/seo/useHead';
    import { TEATRO_HASH_RACING_FERROL } from '@/constants/teatros';

    export default {
        props: ['id_persona', 'pin'],
        data() {
            return {
                mensaje: null,
                loading: false,
                abono: null,
                data: {}
            }
        },
        created() {
            useHead('Mi abono');
        },
        computed: {
            // Racing de Ferrol no usa el QR de AVET en el abono.
            esFerrol() {
                return this.$store.getters.getTeatro?.hash === TEATRO_HASH_RACING_FERROL;
            },
            // Eldense no usa las acciones LFP de este portal.
            showLfpActions() {
                return this.teatro.hash !== TEATRO_HASH_CD_ELDENSE;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            buscarAbono(data) {
                this.data = data;
                this.loading = true;
                data.filters = data;
                data.tid = this.configuracion.hash_teatro;
          
                this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar.lfp'), data).then(res => {
                    this.abono = res.data.data;
                    this.abono.persona_info.pin = data.pin;
                }).catch(error => {
                    this.mensaje = error.response.data.message;
                    this.$toast.error(this.mensaje);
                }).finally(() => {
                    this.loading = false;                 
                });
            },
            editarDatos(data) {
                this.loading = true;
                data.filters = {};
                data.tid = this.configuracion.hash_teatro;
          
                this.$store.dispatch(this.config.getVuexAlias('front.abonados.lfp.editar'), data).then(res => {
                    this.$toast.success('Abono editado correctamente');
                    var info_abono = {};
                    info_abono.id_persona = data.id_persona;
                    info_abono.pin = data.pin;
                    this.buscarAbono(info_abono);
                }).catch(error => {
                    console.log(error);
                    this.mensaje = 'Ha ocurrido un error';
                    this.$toast.error(this.mensaje);
                }).finally(() => {
                    this.closeModal('editarDatos');
                    this.loading = false;                 
                });
            },
            getPdfEnlace() {
                return this.config.API_BASE + '/lfp/front/abono/pdf?tid=' + this.configuracion.hash_teatro + '&id_persona=' + this.data.id_persona + '&pin=' + this.data.pin;
            },
            async getWalletEnlace() {
                let params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        id_persona: this.data.id_persona,
                        pin: this.data.pin
                    },
                }
                this.$store.dispatch(this.config.getVuexAlias('front.abonados.descargar.wallet'), params).then(res => {
                    window.open(res.data.url_wallet, '_blank');
                });
            },
            showModal(modal){ 
                this.$modal.show(modal);

                if (modal === 'listadoPartidos') {
                    setTimeout(() => {
                        this.$refs.partidosModal.getPartidos();
                    }, 300);
                }
            },
            closeModal(modal){
                this.mensaje = null;
                this.$modal.hide(modal);
            },
            cambiarPIN(data){
                this.loading = true;
                data.tid = this.configuracion.hash_teatro;

                this.$store.dispatch(this.config.getVuexAlias('lfp.abono.cambio.pin'), data).then(res => {
                    this.loading = false;
                    this.closeModal();
                    this.$toast.success(res.data.message);
                    this.data.pin = data.pin_new;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.loading = false;                 
                });
            }
        },
        components: {
            BuscarAbonado, CambioPin, EditarDatos, Partidos, PortalAbonadosComponent
        }
    }
</script>
